import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#fb5d2e', 0.16),
  // 500_16: alpha('#919EAB', 0.16), comment  uses before
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8)
};

const PRIMARY = {
  // main: '#05164d',
  main: '#212668',
  mainColor: '#fb5d2e', // setting this color on global project
  dark: "#4b7bec",
  contrastText: '#fff'
};
const CUSTOM = {
  main: GREY[500_6],
  dark: GREY[500_6],
  contrastText: '#fff'
};
const TEXT = {
  main: "#000",
  dark: "#fff",
  contrastText: '#fff'
};
const SECONDARY = {
  main: '#FF4438',
  dark: '#B2342B',
  contrastText: '#fff'
};
const INFO = {
  main: '#A5BAC9',
  dark: '#0C53B7',
  contrastText: '#fff'
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800]
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800]
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff'
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4']
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  custom: { ...CUSTOM },
  textcolor: { ...TEXT },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  functionalityBtn: '#6e6e6e',
  action: {
    // hover: "#ff7675",
    // selected: GREY[500_16],
    selected: '#F27534',
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  },

};

const palette = {
  light: {
    ...COMMON,
    text: {
      primary: GREY[800],
      // primary: GREY[800],
      dark: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
      // buttonText: '#4582e0',
      buttonTextHead: '#5F6368', // adding header button color in staff pages
      // buttonText: '#fb5d2e',
      buttonText: '#e67e22',
      sidebarPrimaryText: '#ffffff',
      sidebarSecondaryText: '#212668',
      tableprimaryBorder: '#95a5a6',
      primaryBorder: '#dddde7',
      primaryBolderBorder: '#DEE2E6',
    },
    background: {
      paper: '#fff',
      buttonPaper: '#212668', // changing the Add emp button color, this is custom theme button background color

      default: '#fff',
      custom: "#05164d",
      neutral: GREY[200]
    },
    graphColors: {
      graphColor: ['#3CB8E1', '#FFCB4E', '#FF935A', '#92DA9B', '#958CE5'],
      graphColorY: '#FFCB4E', // Y stand for yello color
      graphColorLR: '#FF935A', // LR stand for light-red color
      graphColorLG: '#92DA9B', // Lg stand for light-green color
      graphColorV: '#958CE5', // V stand for voilate color
    },
    action: { active: GREY[600], ...COMMON.action }
  },
  dark: {
    ...COMMON,
    text: { primary: '#fff', dark: GREY[800], secondary: GREY[500], disabled: GREY[600], buttonText: '#d35400', sidebarPrimaryText: '#ffffff', sidebarSecondaryText: GREY[800], tableprimaryBorder: '#95a5a6', primaryBorder: '#fff', primaryBolderBorder: '#DEE2E6', },
    background: { paper: GREY[800], default: GREY[900], custom: "#1A0A50", neutral: GREY[500_16] },
    action: { active: GREY[500], ...COMMON.action }
  }
};

export default palette;
